import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import Avatar from "components/commons/Avatar";
import { SortOrder } from "primereact/api";
import { NavLink } from "react-router-dom";
import AnonymousAvatar from "components/commons/AnonymousAvatar";
import AvatarMini from "components/commons/AvatarMini";
import AnonymousAvatarMini from "components/commons/AnonymousAvatarMini";
import SystemAvatarMini from "components/commons/SystemAvatarMini";
import { getModuleColor } from "app/Module";


function LogTable({
    logData,
    showAgent = true,
    thirdPerson = true,
    totalElements, currentPage, pageSize, onPageChange, onPageSizeChange
}) {

    const agentTemplate = (logRecord) => {
        if (logRecord.agent.type == "USER")
            return <AvatarMini displayName={logRecord.agent.displayName} guid={logRecord.agent.guid} />

        if (logRecord.agent.type == "ANONYMOUS_USER")
            return <AnonymousAvatarMini />

        if (logRecord.agent.type == "SYSTEM")
            return <SystemAvatarMini displayName={logRecord.agent.displayName} guid={logRecord.agent.guid} />
    }

    const subjectTemplate = (logRecord) => {
        let subjectPathname
        let subjectState
        let subjectIcon
        switch (logRecord.subject.type) {
            case "USER":
                subjectPathname = "/dashboard/employees/see-employment"
                subjectState = { userGUID: logRecord.subject.guid }
                subjectIcon = <i className="fa-solid fa-user"></i>
                break
            case "OVERTIME_REQUEST":
                subjectPathname = "/dashboard/overtimes"
                subjectState = { userGUID: logRecord.subject.guid }
                subjectIcon = <i className="fa-regular fa-calendar-plus"></i>
                break
            case "ABSENCE_REQUEST":
                subjectPathname = "/dashboard/absences/manage"
                subjectState = { userGUID: logRecord.subject.guid }
                subjectIcon = <i className="fa-solid fa-calendar-check"></i>
                break
            case "COMPANY":
                subjectIcon = <i className="fas fa-building"></i>
                break
            case "WHISTLE":
                subjectPathname = "/dashboard/whistle/dashboard"
                subjectState = { guid: logRecord.subject.guid }
                subjectIcon = <i className="fa-solid fa-circle-exclamation"></i>
                break
            case "COST_REFUND":
                subjectPathname = "/dashboard/costRefunds"
                subjectState = { guid: logRecord.subject.guid }
                subjectIcon = <i className="fa-solid fa-receipt"></i>
                break
            case "SETTINGS":
                subjectIcon = <i className="fa-solid fa-gears"></i>
                break
        }
        return <NavLink className={"btn btn-dark"} to={{ pathname: subjectPathname }} state={subjectState}>{subjectIcon} {logRecord.subject.displayName}</NavLink>
    }

    const eventTemplate = (logRecord) => {
        return <>{thirdPerson ? "has" : "you have"} {logRecord.eventType}</>
    }

    const eventModuleTemplate = (logRecord) => {
        return <span className="opacity-75" style={{ color: getModuleColor(logRecord.module) }}>{logRecord.module}</span>
    }
    const eventIconTemplate = (logRecord) => {
        let icon
        switch (logRecord.eventType) {
            case "ENABLED":
            case "ACCEPTED":
            case "SOLVED":
                icon = <i className="fa-solid fa-circle-check text-success"></i>
                break
            case "CANCELED":
                icon = <i className="fa-solid fa-ban text-secondary"></i>
                break
            case "DELETED":
                icon = <i className="fa-solid fa-trash-can"></i>
                break

            case "DENIED":
                icon = <i className="fa-solid fa-circle-xmark text-danger"></i>
                break
            case "DISABLED":
                icon = <i className="fa-solid fa-ban text-warning"></i>
                break
            case "REGISTERED":
            case "ADDED":
                icon = <i className="fa-solid fa-circle-plus text-primary"></i>
                break
            case "EDITED":
                icon = <i className="fa-solid fa-pen-to-square"></i>
                break
            case "SENT":
                icon = <i className="fa-solid fa-paper-plane"></i>
                break
            case "RESET":
                icon = <i className="fa-solid fa-repeat"></i>
                break


            default: <></>
        }
        return icon
    }

    const timestampTemplate = (logRecord) => {
        return new Date(logRecord.timestamp).toLocaleString()
    }

    const dateValue = (logRecord) => {
        return new Date(logData.timestamp)
    }

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="dd/mm/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
    };

    return (
        <>
            <DataTable
                dataKey="timestamp"
                value={logData}
                stripedRows
                tableStyle={{ minWidth: '50rem' }}
                paginator
                lazy
                rowsPerPageOptions={[5, 10, 25, 50]}
                rows={pageSize}
                totalRecords={totalElements}
                first={currentPage * pageSize}
                onPage={(e) => {
                    onPageChange(e.page);
                    onPageSizeChange(e.rows);
                }}

            >
                <Column field="module" header="Module" body={eventModuleTemplate}></Column>
                {
                    showAgent &&
                    <Column field="agent.displayName" body={agentTemplate} header="Agent"  ></Column>
                }
                <Column body={eventIconTemplate}></Column>
                <Column body={eventTemplate} header="Event" field="eventType"  ></Column>
                <Column body={subjectTemplate} field="subject.displayName" header="Subject"  ></Column>
                <Column body={timestampTemplate} header="Time" field="timestamp"  ></Column>
            </DataTable>


        </>
    )

}

export default LogTable